import { useUi, type ThemeMode } from "@/state/ui";

const NEXT: Record<ThemeMode, ThemeMode> = { system: "dark", dark: "light", light: "system" };
const ICON: Record<ThemeMode, string> = { system: "◐", dark: "●", light: "○" };

/**
 * Cycles system → dark → light. Icon only unless the top bar (container) is
 * ≥ 1200px wide, or `labelled` (the phone top bar's ⋯ menu).
 */
export function ThemeToggle({ labelled = false }: { labelled?: boolean }) {
  const mode = useUi((s) => s.themeMode);
  const set = useUi((s) => s.setThemeMode);
  return (
    <button
      type="button"
      className={labelled ? "ctl topbar-ctl shrink-0 whitespace-nowrap" : "ctl shrink-0 whitespace-nowrap"}
      title={`theme: ${mode} (click to change)`}
      onClick={() => set(NEXT[mode])}
      aria-label={`theme: ${mode}`}
    >
      <span aria-hidden>{ICON[mode]}</span>
      <span className={labelled ? undefined : "hidden @min-[1200px]:inline"}>
        {" "}
        {labelled ? `theme: ${mode}` : mode}
      </span>
    </button>
  );
}
